// extracted by mini-css-extract-plugin
module.exports = {"container":"NotFoundPage_container__2TBYn","title":"NotFoundPage_title__22cGv","body":"NotFoundPage_body__f5nFV"};